import DPDropDown from "framework/components/DPDropDown";
import DPTextBox from "framework/components/DPTextBox";
import { Text } from "framework/validators/TextValidation";
import { Button, Col, Row } from "reactstrap";


const TransactionUpdateContent = ({
    transactionList,
    formData,
    setFormData,
    fromLocations,
    toLocations,
    getTransactionData
}) => {
    return (
        <>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Select Transaction Type"
                        textType="text"
                        optionGroup={transactionList}
                        selectedGroup={formData.selectedTxn}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                selectedTxn: e.value
                            })
                        }}
                        disabled={formData.disableDocumentNo}
                    // disabled={disabled}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Transaction No"
                        textType="text"
                        maxLength="50"
                        value={formData.documentNo}
                        onChange={(e) => {

                            const validated = Text(e.target, 50, true, false, "upper", false)

                            setFormData({
                                ...formData,
                                documentNo: validated
                            })
                        }}
                        onBlur={(e) => {
                            getTransactionData(e.target.value)
                        }}
                        disabled={formData.disableDocumentNo}
                    />
                </Col>
                {/* <Col sm={12} md={6} className="mb-4-sm">
                    <Button
                        onClick={() => {
                            //tog_backdrop()
                        }}
                        color="success"
                        className="btn-sm"
                        disabled={formData.disableDocumentNo}
                    >
                        <i
                            className="mdi mdi-search-web"
                            style={{ fontSize: "12px" }}
                        ></i>
                    </Button>
                </Col> */}
            </Row>
            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="From Location"
                        textType="text"
                        optionGroup={fromLocations}
                        selectedGroup={formData.fromLocation}
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row hidden={formData.disableLocations}>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="To Location"
                        textType="text"
                        optionGroup={toLocations}
                        selectedGroup={formData.toLocation}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                toLocation: e.value
                            })
                        }}
                    // disabled={disabled}
                    />
                </Col>
            </Row>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
        </>
    );
}

export default TransactionUpdateContent;